import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('calendarioAttivita');
export const actions = helper.createActions('calendarioAttivita', actionTypes);